import React from 'react';
import { motion } from 'framer-motion';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import AnimatedText from '../AnimatedText';

interface NoResultsProps {
  t: {
    noResultsFound: string;
    tryDifferentSearch: string;
  };
}

/**
 * NoResults Component
 * Displays a message when no search results are found
 */
const NoResults: React.FC<NoResultsProps> = ({ t }) => {
  return (
    <div className="absolute top-full left-0 right-0 mt-2 bg-white dark:bg-gray-800 rounded-xl shadow-xl border border-gray-300 dark:border-gray-700 p-12 z-50 transition-colors duration-300">
      <div className="text-center">
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{
            type: "spring",
            stiffness: 200,
            damping: 15,
            delay: 0.1
          }}
          className="mx-auto mb-6 flex justify-center"
        >
          <div className="w-40 h-40 flex items-center justify-center">
            <DotLottieReact
              src="/no_results.lottie"
              loop
              autoplay
              style={{ width: '100%', height: '100%', objectFit: 'contain' }}
            />
          </div>
        </motion.div>
        <AnimatedText
          text={t.noResultsFound}
          className="text-gray-700 dark:text-gray-300 font-semibold text-lg mb-2 transition-colors duration-300"
          delay={0.2}
          staggerDelay={0.02}
        />
        <motion.p
          className="text-sm text-gray-500 dark:text-gray-400 transition-colors duration-300"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          {t.tryDifferentSearch}
        </motion.p>
      </div>
    </div>
  );
};

export default NoResults;
